/* eslint-disable react-hooks/exhaustive-deps */
import {  useForm } from 'react-hook-form';
import { useEffect, useState } from 'react';
import { Button, Card, Col, Container, Form, Modal, Pagination, Row, Table } from 'react-bootstrap';
import { CrudInterface } from '../../../@types/entity/interface/crud-interface';
import { UseAlert } from 'hook/alert-hook';
import { UseAlertModal } from 'hook/alert-modal-hook';
import { Footer } from 'components/footer/footer-component';
import { Loading } from 'components/loading/loading-component';
import { SelectOptionInterface } from '../../../@types/entity/interface/select-option-interface';
import { SelectProvider } from 'components/select/provider-select-component';
import { RegionalEntity, RegionalInputs } from '../../../@types/entity/regional-entity';
import { TableHeaderFixedStyled } from 'pages/style/table/table-header-fixed-styled';
import { TitleGroupComponent } from '../../../components/title/title-group-component';

type Props = {
  modelMethods: CrudInterface<RegionalEntity>,
}

const tableDescriptions: {
  label: string,
  align: 'center' | 'left' | 'right'
}[] = [
    // { label: "ID", align: "center" },
    { label: 'Código', align: 'center' },
    { label: 'Código Fornecedor', align: 'center' },
    { label: 'Nome', align: 'left' },
  ];

const titlePage = 'Cadastrar Regional';

const RegionalPage: React.FC<Props> = ({ modelMethods }: Props) => {

  /**
   *
   * ALERT / ALERT MODAL
   *
   */
  const { showAlert } = UseAlert();
  const { messageAlertModal, showAlertModal } = UseAlertModal();
  const cleanAlertModal = () => showAlertModal({ show: false, content: '', color: '' });

  function AlertModal() {
    if (messageAlertModal?.show) {
      return (
        <div className={'alert alert-' + messageAlertModal.color + ' fade show mx-5 mt-2 alert-dismissible'}
          role='alert'>
          {messageAlertModal.content}
          {!messageAlertModal.time &&
            <button
              type='button'
              className='ms-1 btn-close btn-sm'
              data-bs-dismiss='alert'
              aria-label='Close'
              onClick={() => cleanAlertModal()}>
            </button>
          }
        </div>
      );
    } else {
      return (
        <></>
      );
    }
  }

  /**
   *
   * FORM HOOK
   *
   */
  const { register, handleSubmit, reset, getValues, setValue, formState: { errors }, control } = useForm<RegionalInputs>();

  function clearField(): void {
    // LIMPA OS CAMPOS
    reset({
      codigo: '',
      nome: '',
      estado: '',
      dataCadastro: '',
      fornecedor: 0,
      perfil: 0,
    });
  }

  /**
   *
   * ERROR
   *
   */
  const [listError, updateListError] = useState<string[]>([]);

  /**
   *
   * CRUD MODEL / MODELS
   *
   */
  const [listModel, updateListModel] = useState<RegionalEntity[]>([]);

  async function handleListModel(params?: {
    pagination?: string,
    idProvider?: number
  }): Promise<void> {

    updateIdProvider(params?.idProvider);

    var modelRequest = { idProvider: params === undefined ? idProvider : params?.idProvider };

    updateLoading(true);
    // BUSCA LISTAGEM DE MODELS
    await modelMethods.getAll(modelRequest)
      .then((response) => {
        updateListModel(response.body);
      })
      .catch(error => updateListError([...listError, error]));

    updateLoading(false);

    handleCloseModal();
  }

  async function handleModel(id: number): Promise<void> {
    // BUSCA MODEL
    await modelMethods.getById(id)
      .then(response => {
        // SETAR OUTROS CAMPOS
        setValue('id', response.id!);
        setValue('codigo', response.codigo);
        setValue('nome', response.nome);
        setValue('estado', response.estado);
        setValue('dataCadastro', response.dataCadastro);
        setValue('fornecedor', response.fornecedor);
        setValue('perfil', response.perfil);
      })
      .catch(error => updateListError([...listError, error]));
  }

  async function handleCreteOrEdit(modelFields: RegionalInputs): Promise<void> {
    // EDITA OU CRIA
    const model: RegionalInputs = {
      codigo: modelFields.codigo,
      nome: modelFields.nome,
      estado: modelFields.estado,
      dataCadastro: '2022-08-09T17:14:56.303Z',
      fornecedor: modelFields.fornecedor,
      perfil: modelFields.perfil,
    };

    if (inEditing === true)
      await modelMethods.edit(model, modelFields.id!)
        .then(() => showAlert({ show: true, content: 'Editado com sucesso', color: 'success', time: 5000 }))
        .catch(error => updateListError([...listError, error]));
    else
      await modelMethods.create(model)
        .then(() => showAlert({ show: true, content: 'Salvo com sucesso', color: 'success', time: 5000 }))
        .catch(error => updateListError([...listError, error]));

    await handleListModel({ idProvider: idProvider });
  }

  async function handleDelete(): Promise<void> {
    // DELETA
    let id: number = getValues('id')!;

    await modelMethods.remove(id)
      .then((response) => {
        if (response === true)
          showAlert({ show: true, content: 'Deletado com sucesso', color: 'success', time: 5000 });
        else
          showAlert({ show: true, content: 'Não Foi possível deletar, verifique suas credenciais', color: 'danger', time: 5000 });
      })
      .catch(error => updateListError([...listError, error]));

    await handleListModel({ idProvider: idProvider });
  }

  /**
   *
   * MODAL
   *
   */
  const [inEditing, updateInEditing] = useState<boolean>(false);
  const [openModal, updateOpenModal] = useState<boolean>(false);

  async function handleModalEdit(id: number): Promise<void> {
    // ABRE MODAL PARA EDICAO
    await handleModel(id);
    updateInEditing(true);
    updateOpenModal(true);
  }

  function handleModalCreate() {
    // ABRE MODAL PARA CRIACAO
    updateLoading(false);
    updateOpenModal(true);
    updateInEditing(false);
  }

  function handleCloseModal() {
    // FECHA MODAL
    clearField();
    updateInEditing(false);
    updateOpenModal(false);
  }

  /**
   *
   * LOADING
   *
   */
  const [loading, updateLoading] = useState<boolean>(false);

  /**
   *
   * PROVIDER
   *
   */
  const [idProvider, updateIdProvider] = useState<number>();
  const [modelProvider, updateModelProvider] = useState<SelectOptionInterface>();

  function handleSelectProvider(filial: {
    value: number,
    label: string
  }) {
    updateModelProvider(filial);
    updateIdProvider(filial.value);
    handleListModel({ idProvider: filial.value });
  }

  function CreateSelectProvider() {
    return (
      <div className='m-3'>
        <Row className='d-flex align-items-center justify-content-start'>
          <Col md={1}>
            <Form.Label>Fornecedor:</Form.Label>
          </Col>
          <Col md={3}>
            <SelectProvider passOnTheValue={handleSelectProvider} defaultValue={modelProvider} />
          </Col>
        </Row>
      </div>
    );
  }

  /**
   *
   * INIT
   *
   */
  useEffect(() => {
  }, []);

  /**
   *
   * RENDER
   *
   */
  return (
    <>
      {loading && <Loading />}
      {!loading && <CreatePageContent />}

      <Modal show={openModal} onHide={handleCloseModal} size={'xl'} fullscreen={'md-down'}>
        <Container>
          <form onSubmit={handleSubmit(handleCreteOrEdit)} className='mt-0' noValidate>
            <Modal.Header closeButton>
              <Modal.Title className='ms-3 lead'
                style={{ fontSize: '30px' }}>{inEditing ? 'EDITAR' : 'NOVO'}</Modal.Title>
            </Modal.Header>
            <AlertModal />
            <Modal.Body>

              <Form.Control type='hidden' {...register('id')} />

              <Row className='mt-3'>
                <Col md={2}>
                  {/* <Form.Label column>Codigo: <h6>{getValues("codigo")}</h6></Form.Label> */}
                  <Form.Label column>Codigo: <h6>{getValues('id')}</h6></Form.Label>
                </Col>
                <Col md={7}>
                  <Form.Label>Nome:</Form.Label>
                  <Col>
                    <Form.Control type='text' {...register('nome')} />
                  </Col>
                </Col>
                <Col md={3}>
                  <Form.Label>Código Fornecedor:</Form.Label>
                  <Col>
                    {/* <Form.Control type="text" {...register("fornecedor")} /> */}
                    <Form.Control type='text' {...register('codigo')} />
                  </Col>
                </Col>
              </Row>

            </Modal.Body>
            <Modal.Footer className='d-flex justify-content-start'>
              <Button variant='primary' size='sm' type='submit'>Salvar</Button>
              <Button variant='outline-primary' size='sm' onClick={clearField}>Limpar</Button>
              {inEditing && <Button variant='danger' size='sm' onClick={handleDelete}>Deletar</Button>}
            </Modal.Footer>
          </form>
        </Container>
      </Modal>
    </>
  );

  /**
   *
   * CREATE TABLE
   *
   */
  function CreateTable() {
    if (listModel !== undefined)
      return (
        <TableHeaderFixedStyled>
          <Table>
            <thead>
              <tr>
                {tableDescriptions.map((value, index) => {
                  return (
                    <th className='px-1' key={index}>
                      <div>
                        <p style={{ whiteSpace: 'nowrap', textAlign: value.align }} className='m-1'>{value.label}</p>
                      </div>
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {listModel.map((value, index) => {
                return (
                  <tr key={index} onClick={() => handleModalEdit(value.id!)}>
                    <td align='center'>{value.id}</td>
                    <td align='center'>{value.codigo}</td>
                    {/* <td align='center' >{value.fornecedor}</td> */}
                    <td align='left'>{value.nome}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </TableHeaderFixedStyled>

      );
    else
      return (
        <TableHeaderFixedStyled>
          <Table>
            <thead>
              <tr>
                {tableDescriptions.map((value, index) => {
                  return (<th key={index} style={{ whiteSpace: 'nowrap', textAlign: value.align }}>{value.label}</th>);
                })}
              </tr>
            </thead>
          </Table>
        </TableHeaderFixedStyled>
      );
  }

  /**
   *
   * CREATE INITIAL PAGE
   *
   */
  function CreatePageContent() {
    return (
      <>
        <div>
          <div className='mx-4'>
            <TitleGroupComponent titlePage={titlePage}>
              <Row>
                <Col className='d-flex align-items-center justify-content-end'>
                  <Button variant='primary' onClick={handleModalCreate} size='sm'>Novo</Button>
                </Col>
              </Row>
            </TitleGroupComponent>
          </div>
          <div className='mx-2'>
            <Card>
              <CreateSelectProvider />

              {listModel.length > 0 &&
                <Card.Body>
                  <div>
                    <CreateTable />
                  </div>
                </Card.Body>
              }

              {listModel.length === 0 &&
                <div className='d-flex align-items-center justify-content-center'>
                  <p className='m-5'>Não há nada a ser exibido, clique em processar ou tente mais tarde</p>
                </div>
              }

            </Card>
          </div>
        </div>
        <Footer />
      </>
    );
  }
};

export default RegionalPage;
